import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { clsx } from 'clsx';
import { useStore } from '@/store';

const TABS = [
  {
    label: 'Book Flight',
    icon: (active: boolean) => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8}
        className="w-6 h-6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 3L3 10.5l7 2.5 2.5 7L21 3z" />
        <path d="M10 13l5-5" />
      </svg>
    ),
    paths: ['/search', '/results', '/seats', '/passengers', '/payment', '/confirmation'],
    navigate: '/search',
  },
  {
    label: 'My Flights',
    icon: (active: boolean) => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8}
        className="w-6 h-6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4V9z" />
        <path d="M14 7v2M14 11v2M14 15v2" />
      </svg>
    ),
    paths: ['/my-flights'],
    navigate: '/my-flights',
  },
  {
    label: 'Profile',
    icon: (active: boolean) => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8}
        className="w-6 h-6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
      </svg>
    ),
    paths: ['/profile'],
    navigate: '/profile',
  },
  {
    label: 'Contact',
    icon: (active: boolean) => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8}
        className="w-6 h-6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.1a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.39h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.73a16 16 0 0 0 6.29 6.29l.92-.92a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    ),
    paths: ['/contact'],
    navigate: '/contact',
  },
];

const ADMIN_TAB = {
  label: 'Admin',
  icon: (active: boolean) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8}
      className="w-6 h-6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  ),
  paths: ['/admin'],
  navigate: '/admin',
};

export function BottomNav() {
  const navigate  = useNavigate();
  const { pathname } = useLocation();
  const isAdmin   = useStore((s) => s.isAdmin);

  const tabs = isAdmin ? [...TABS, ADMIN_TAB] : TABS;

  return (
    <nav className="bg-white border-t border-gray-200 px-2 pb-safe sticky bottom-0 z-20">
      <div className="flex items-center">
        {tabs.map((tab) => {
          const active = tab.paths.some((p) => pathname.startsWith(p));
          return (
            <button
              key={tab.label}
              onClick={() => navigate(tab.navigate)}
              className={clsx(
                'flex-1 flex flex-col items-center gap-1 py-3 transition-colors',
                active ? 'text-brand-500' : 'text-gray-400 hover:text-gray-600',
              )}
            >
              {tab.icon(active)}
              <span className={clsx('text-[10px] font-medium', active && 'text-brand-500')}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
